import { render, staticRenderFns } from "./CardBackTooSmall.vue?vue&type=template&id=370af6e0&scoped=true"
var script = {}
import style0 from "./CardBackTooSmall.vue?vue&type=style&index=0&id=370af6e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "370af6e0",
  null
  
)

export default component.exports